<template lang="pug">
  tr
    td(v-for="column in columns" v-html="data[column.id]")
</template>

<script>

export default {
  name: 'table-row',
  props: [ 'columns', 'data' ]
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// table-row.vue?2127f1c0